(function () {
  'use strict';

  function init() {
    var fabs = document.querySelectorAll('.ipta-whatsapp-fab');

    fabs.forEach(function (fab) {
      var button = fab.querySelector('.ipta-whatsapp-fab__button');
      var overlay = fab.querySelector('.ipta-whatsapp-fab__overlay');
      var bubbles = fab.querySelectorAll('.ipta-whatsapp-fab__bubble');
      var whatsappNumber = fab.getAttribute('data-whatsapp-number') || '';

      if (!button) return;

      var isOpen = false;

      function open() {
        if (isOpen) return;
        fab.classList.add('ipta-whatsapp-fab--open');
        fab.setAttribute('aria-expanded', 'true');
        isOpen = true;
      }

      function close() {
        if (!isOpen) return;
        fab.classList.remove('ipta-whatsapp-fab--open');
        fab.setAttribute('aria-expanded', 'false');
        isOpen = false;
      }

      function toggle() {
        if (isOpen) {
          close();
        } else {
          open();
        }
      }

      button.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
        if (isOpen) {
          setTimeout(function () {
            var firstBubble = fab.querySelector('.ipta-whatsapp-fab__bubble');
            if (firstBubble) firstBubble.focus();
          }, 100);
        }
      });

      if (overlay) {
        overlay.addEventListener('click', function () {
          close();
        });
      }

      bubbles.forEach(function (bubble) {
        bubble.addEventListener('click', function (e) {
          e.stopPropagation();
          var message = bubble.getAttribute('data-message') || '';
          if (whatsappNumber && message) {
            var url =
              'https://wa.me/' +
              whatsappNumber +
              '?text=' +
              encodeURIComponent(message);
            window.open(url, '_blank', 'noopener,noreferrer');
          }
          close();
          if (button) {
            setTimeout(function () {
              button.focus();
            }, 150);
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) {
          close();
          if (button) {
            setTimeout(function () {
              button.focus();
            }, 50);
          }
        }
      });

      fab.addEventListener('keydown', function (e) {
        if (!isOpen || e.key !== 'Tab') return;

        var focusableElements = fab.querySelectorAll(
          '.ipta-whatsapp-fab__button, .ipta-whatsapp-fab__bubble:not([disabled])'
        );

        if (focusableElements.length === 0) return;

        var firstFocusable = focusableElements[0];
        var lastFocusable = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      });

      fab.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
